import { getSingleTspType, TspPagePayee, TspType } from '@entities/tsp'
import { eventContents } from '@shared/lib/gtm/redesign'
import type { FunnelContent } from '@shared/lib/gtm/redesign/types'

export const getTspEventContent = (payee: TspPagePayee): FunnelContent => {
  const tspType = payee ? getSingleTspType(payee) : undefined

  if (tspType === TspType.KEYS) {
    return eventContents.igrovyeKluchi
  }

  if (tspType === TspType.SERVICES) {
    return eventContents.servisy
  }

  return eventContents.igry
}
